var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.showFilters && _vm.servicesView == "map",
          expression: "( !showFilters && servicesView == 'map' )",
        },
      ],
      attrs: { id: "charging-station-legend" },
    },
    [
      _c("div", { staticClass: "grid-x" }, [
        _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
          _c("span", { staticClass: "legend-title" }, [
            _vm._v(_vm._s(_vm.$t("legend.label"))),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "large-6 medium-6 small-6 cell legend-row" },
      [
        _c("img", {
          attrs: { src: "/img/charging-station-middle-orange-marker-big.svg" },
        }),
        _vm._v(" ≤22 kW\n        "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "large-6 medium-6 small-6 cell legend-row" },
      [
        _c("img", {
          attrs: { src: "/img/charging-station-aqua-blue-marker-big.svg" },
        }),
        _vm._v(" 50 kW\n        "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "large-6 medium-6 small-6 cell legend-row" },
      [
        _c("img", {
          attrs: { src: "/img/charging-station-grass-green-marker-big.svg" },
        }),
        _vm._v(" 150 kW\n        "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "large-6 medium-6 small-6 cell legend-row" },
      [
        _c("img", {
          attrs: { src: "/img/charging-station-petrol-blue-marker-big.svg" },
        }),
        _vm._v(" ≥300 kW\n        "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }